import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { PackageDataService } from '../../data-services/package.service';
import { LazyLoadEvent } from 'primeng/api';
import { SelectItem, MessageService } from 'primeng/api';
import { RequisitionDataService } from '../../data-services/requisition.service';
import { UserDataService } from '../../data-services/user.service';
import { DialogService } from 'primeng/dynamicdialog';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { FormsModule } from '@angular/forms';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { HasClaimDirective } from '../../security/has-claim.directive';
import { DateAge, DateAgeBadge } from '../../helpers/dateAge.pipe';
import { ReceivingPackageComponent } from '../receiving-list/receiving.package';

interface FilterOption {
  value: number;
  label: string;
}

@Component({
  selector: 'app-packageException-list',
  templateUrl: './packageException.list.html',
  providers: [DialogService, MessageService],
  imports: [ButtonModule, AccordionModule, FormsModule, Toast, CommonModule, TableModule, SelectModule, DatePickerModule, CheckboxModule, HasClaimDirective, DateAge, DateAgeBadge, ReceivingPackageComponent]
})
export class PackageExceptionListComponent implements OnInit {

  @ViewChild('packageImage') packageImage;

  barcode = "";
  barcodeReading = false;

  constructor(private packageDataService: PackageDataService,
    private requisitionService: RequisitionDataService,
    public dialogService: DialogService,
    private userService: UserDataService,
    private datepipe: DatePipe,
    private messageService: MessageService) {
  }

  packages;
  statuses: SelectItem[] = [];
  facilities: SelectItem[] = [];
  testNames: SelectItem[] = [];
  resolveUsers: SelectItem[];
  totalRecords: number;
  cols: any[];
  includeDateFilterOptions: FilterOption[] = [
    { value: 0, label: "No Date Filter" },
    { value: 1, label: "Only Packages In This Date Range" },
  ];

  includeDateFilterValue: FilterOption = this.includeDateFilterOptions[0];

  loading: boolean;
  processingExceptions: boolean = false;
  selectedStatus: SelectItem;
  filter: any = {};
  filterDisplay: string = "None";
  queryParams: string;
  sub: any;

  ngOnInit() {

    this.userService.getDistinctAssignableResolveUsers().subscribe((data: any) => {
      data.push({ label: 'Unassigned', value: 'Unassigned'});
      this.resolveUsers = data;
      this.resolveUsers.unshift({ label: 'All', value: null });
    });

    this.cols = [
      { field: 'TrackingNumber', header: 'Tracking' },
      { field: 'FromName', header: 'From' },
      { field: 'ClientName', header: 'Client' },
      { field: 'ReceivedDate', header: 'Received On' },
      { field: 'OpenedDate', header: 'Opened' },
      { field: 'CompletedDate', header: 'Completed' },
      { field: 'RequisitionCount', header: 'Samples' },
      { field: 'RequisitionExceptionCount', header: 'Exceptions' },
      { field: 'RequisitionRejectCount', header: 'Rejects' },
      { field: 'ResolveTeamAssignedTo', header: 'Assigned' },
    ];
    this.filter.AssignedTo = null;
    this.filter.IncludeExceptions = true;
    this.filter.BeginReceivedDate = null;
    this.filter.EndReceivedDate = null;
    this.filter.ClientIds = [];
    this.setFilterDescription();
    this.loading = true;
  }

  searchTerm: string = "";
  public handleSearchKey(event, reqlist) {
    if (event.keyCode == 13) {
      this.includeDateFilterValue = this.includeDateFilterOptions[0];

      this.filter.BeginReceivedDate = null;
      this.filter.EndReceivedDate = null;
      this.filter.ClientIds = [];
      reqlist.filterGlobal(event.target.value, 'contains');
      this.searchTerm = event.target.value;
      this.filterDisplay = this.searchTerm;
      event.preventDefault();
    }
  }

  lastLoad: LazyLoadEvent;
  public loadPackagesLazy(event: LazyLoadEvent) {
    this.loading = true;
    if (event) {
      this.lastLoad = event;
    } else {
      this.lastLoad.first = 0;
      event = this.lastLoad;
    }
    this.packageDataService.getList(event.first, event.rows, event.sortField, event.sortOrder, event.filters, this.filter).subscribe((data: any) => {
      this.totalRecords = data.totalRows;
      this.packages = data.rows;

      if (this.packages.length == 1) {
        this.packages[0].showDetail = true;
      }
      else {
        for (var i = 0; i < this.packages.length; i++) {
          this.packages[i].showDetail = false;
        }
      }
      event.filters.global = {};
      this.loading = false;
    });
  }

  applyFilter() {
    this.setFilterDescription();
    this.loadPackagesLazy(null);
  }


  setFilterDescription() {
    this.filterDisplay = "";
    if (this.filter.AssignedTo) {
      this.filterDisplay = this.filterDisplay + "Packages assigned to " + this.filter.AssignedTo + " ";
    }
    if (this.filter.BeginReceivedDate) {
      this.filterDisplay = this.filterDisplay + "After " + this.datepipe.transform(this.filter.BeginReceivedDate, 'MM/dd/yyyy') + " ";
    }
    if (this.filter.EndReceivedDate) {
      this.filterDisplay = this.filterDisplay + "Before " + this.datepipe.transform(this.filter.EndReceivedDate, 'MM/dd/yyyy') + " ";
    }

    if (!this.filterDisplay) {
      this.filterDisplay = "None";
    }
  }

  clearFilter() {
    this.includeDateFilterValue = this.includeDateFilterOptions[0];
    this.filterDisplay = "None";
    this.filter.AssignedTo = null;
    this.filter.BeginReceivedDate = null;
    this.filter.EndReceivedDate = null;
    this.filter.ClientIds = [];
    this.loadPackagesLazy(null);
  }

  public attemptToResolveRequisitionExceptions() {
    this.processingExceptions = true;
    this.requisitionService.attemptToResolveRequisitionExceptionsAll().subscribe((data: any) => {
      this.loadPackagesLazy(null);
      this.processingExceptions = false;
    },
      (err) => {
        this.messageService.add({ severity: 'error', summary: 'Attempt to Resolve Requisition Exceptions', detail: 'Error: ' + err.status });
        this.processingExceptions = false;
      });
  }

  public assignedToFilterChange() {
    return;
  }

  public dateFilterChange(event: any) {
    console.log(event);
    switch (event.value.value) {
      case 0:
        this.filter.EndReceivedDate = null;
        this.filter.BeginReceivedDate = null;
        break;
      case 1:
        this.filter.EndReceivedDate = new Date();
        this.filter.BeginReceivedDate = new Date();
        this.filter.BeginReceivedDate.setDate(this.filter.BeginReceivedDate.getDate() - 5);
        break;
    }

    return;
  }

}
